
import { Vue, Component, Prop } from 'vue-property-decorator';

import { ObjectType } from '@/@types/graphql-types';
import { TitleDetailsNode } from '@/interfaces/title-details-graphql';

import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';
import TitleCreditName from '@/components/details/TitleCreditName.vue';

@Component({
	name: 'TitleCredits',
	components: {
		HiddenHorizontalScrollbar,
		TitleCreditName,
	},
})
export default class TitleCredits extends Vue {
	@Prop({ required: true }) title: TitleDetailsNode;
	@Prop({ default: '' }) role: string;

	get filteredCredits() {
		if (!this.role) {
			return this.credits;
		}
		return this.credits.filter(credit => credit.role === this.role);
	}

	get credits() {
		return (
			(this.title.objectType === ObjectType.ShowSeason
				? this.title.show?.content.credits
				: this.title.content.credits) ?? []
		);
	}
}
